import { JournalEntry, BatchSummary } from '../types/journal';

const PDF_BASE = 'https://invoice-review.system-0f7.workers.dev/pdf';

export const batch1Summary: BatchSummary = {
  batchNumber: 1,
  targetMonth: '2026-03',
  issueDate: '2026-03-31',
  dueDate: '2026-04-27',
  totalDeals: 11,
  totalAmount: 705106,
  patternMatched: 3,
  needsReview: 0,
  blocked: 0,
  approved: 0,
};

export const batch1Entries: JournalEntry[] = [
  {
    id: 'inv_20260417_001',
    rowid: 21473,
    partnerName: '志方秀雄',
    partnerId: 83825363,
    documentType: 'invoice',
    verifiedType: 'invoice',
    issueDate: '2026-03-31',
    dueDate: '2026-04-27',
    grandTotal: 220000,
    taxBreakdown: [{ rate: '10%', subtotal: 200000, tax: 20000 }],
    details: [{
      index: 0, accountName: '研究開発費', accountItemId: 858355848, taxCode: 136,
      taxCodeName: '課対仕入10%', sectionName: '本部', sectionId: 3068540,
      itemName: null, amount: 220000, taxAmount: 20000,
      description: 'スマレジKOTATSU データ連携開発費',
      mappingSource: null,
    }],
    storeName: '本部',
    status: 'approved',
    confidence: 0.97,
    flags: ['パターン未登録'],
    notes: '',
    pdfUrl: `${PDF_BASE}/21473`,
    tNumber: 'T2810252201971',
    invoiceNumber: 'INV-0000000027',
    patternStatus: 'Unknown',
    a2aAgreement: true,
    dialogueRounds: 0,
  },
  {
    id: 'inv_20260417_002',
    rowid: 21472,
    partnerName: '株式会社プレスト',
    partnerId: 83825345,
    documentType: 'invoice',
    verifiedType: 'invoice',
    issueDate: '2026-03-31',
    dueDate: '2026-04-27',
    grandTotal: 63470,
    taxBreakdown: [{ rate: '10%', subtotal: 57700, tax: 5770 }],
    details: [{
      index: 0, accountName: '修繕費', accountItemId: 858355835, taxCode: 136,
      taxCodeName: '課対仕入10%', sectionName: 'Bistrot Gourmand', sectionId: 3068553,
      itemName: null, amount: 63470, taxAmount: 5770,
      description: '照明工事',
      mappingSource: '学習: パターン適合(修繕費)',
    }],
    storeName: 'Bistrot Gourmand',
    status: 'approved',
    confidence: 0.93,
    flags: [],
    notes: 'T番号印影重なり(conf:0.93)',
    pdfUrl: `${PDF_BASE}/21472`,
    tNumber: 'T1020001077712',
    invoiceNumber: 'S260302-NY',
    patternStatus: 'Trusted',
    a2aAgreement: true,
    dialogueRounds: 0,
  },
  {
    id: 'inv_20260417_003',
    rowid: 21804,
    partnerName: '三井倉庫ロジスティクス',
    partnerId: 83825424,
    documentType: 'invoice',
    verifiedType: 'invoice',
    issueDate: '2026-03-31',
    dueDate: '2026-04-27',
    grandTotal: 25311,
    taxBreakdown: [{ rate: '10%', subtotal: 23010, tax: 2301 }],
    details: [{
      index: 0, accountName: '修繕費', accountItemId: 858355835, taxCode: 136,
      taxCodeName: '課対仕入10%', sectionName: 'La SOFFITTA', sectionId: 3068544,
      itemName: null, amount: 25311, taxAmount: 2301,
      description: '設備メンテナンス(技術料+出張+部品)',
      mappingSource: '学習: 修繕費 [4/5一致]',
    }],
    storeName: 'La SOFFITTA',
    status: 'approved',
    confidence: 0.97,
    flags: [],
    notes: '',
    pdfUrl: `${PDF_BASE}/21804`,
    tNumber: 'T6120001163365',
    invoiceNumber: 'S20260702',
    patternStatus: 'Reviewed',
    a2aAgreement: true,
    dialogueRounds: 0,
  },
  {
    id: 'inv_20260417_004',
    rowid: 21803,
    partnerName: '三井倉庫ロジスティクス',
    partnerId: 83825424,
    documentType: 'invoice',
    verifiedType: 'invoice',
    issueDate: '2026-03-31',
    dueDate: '2026-04-27',
    grandTotal: 22690,
    taxBreakdown: [{ rate: '10%', subtotal: 20627, tax: 2063 }],
    details: [{
      index: 0, accountName: '修繕費', accountItemId: 858355835, taxCode: 136,
      taxCodeName: '課対仕入10%', sectionName: '人間関係', sectionId: 3068545,
      itemName: null, amount: 22690, taxAmount: 2063,
      description: '設備メンテナンス(技術料+出張+駐車場)',
      mappingSource: '学習: 修繕費 [4/5一致]',
    }],
    storeName: '人間関係',
    status: 'approved',
    confidence: 0.97,
    flags: [],
    notes: '',
    pdfUrl: `${PDF_BASE}/21803`,
    tNumber: 'T6120001163365',
    invoiceNumber: 'S20260698',
    patternStatus: 'Reviewed',
    a2aAgreement: true,
    dialogueRounds: 0,
  },
  {
    id: 'inv_20260417_005',
    rowid: 21646,
    partnerName: 'レッツエンジョイ東京',
    partnerId: 87886405,
    documentType: 'invoice',
    verifiedType: 'invoice',
    issueDate: '2026-03-31',
    dueDate: '2026-04-27',
    grandTotal: 11000,
    taxBreakdown: [{ rate: '10%', subtotal: 10000, tax: 1000 }],
    details: [{
      index: 0, accountName: '広告宣伝費', accountItemId: 858355826, taxCode: 136,
      taxCodeName: '課対仕入10%', sectionName: 'Bistrot Gourmand', sectionId: 3068553,
      itemName: null, amount: 11000, taxAmount: 1000,
      description: 'デート特集記事掲載料',
      mappingSource: null,
    }],
    storeName: 'Bistrot Gourmand',
    status: 'approved',
    confidence: 0.97,
    flags: ['パターン未登録'],
    notes: '請求書上issue=4/30だが3月分として処理',
    pdfUrl: `${PDF_BASE}/21646`,
    tNumber: 'T5010001203686',
    invoiceNumber: '000108',
    patternStatus: 'Unknown',
    a2aAgreement: true,
    dialogueRounds: 0,
  },
  {
    id: 'inv_20260417_006a',
    rowid: 21474,
    refNumber: 'arica:21474-A',
    partnerName: '日伯コーヒー【人間関係】',
    partnerId: 83825412,
    documentType: 'invoice',
    verifiedType: 'invoice',
    issueDate: '2026-03-31',
    dueDate: '2026-04-27',
    grandTotal: 255600,
    taxBreakdown: [
      { rate: '8%', subtotal: 213852, tax: 17108 },
      { rate: '10%', subtotal: 22400, tax: 2240 },
    ],
    details: [
      {
        index: 0, accountName: '仕入高', accountItemId: 858355808, taxCode: 163,
        taxCodeName: '課対仕入8%軽減', sectionName: '人間関係', sectionId: 3068545,
        itemName: null, amount: 213852, taxAmount: 17108,
        description: 'コーヒー豆(イタリアンロースト)',
        mappingSource: '学習: "コーヒー" → 仕入高 [10/10]',
      },
      {
        index: 1, accountName: '消耗品費', accountItemId: 858355833, taxCode: 136,
        taxCodeName: '課対仕入10%', sectionName: '人間関係', sectionId: 3068545,
        itemName: null, amount: 22400, taxAmount: 2240,
        description: 'カリタ器具代金立替+配送料',
        mappingSource: '学習: "器具" → 消耗品費 [3/3]',
      },
    ],
    storeName: '人間関係',
    status: 'approved',
    confidence: 0.95,
    flags: ['2店舗分割'],
    notes: '人間関係分。ラソフィッタ分は#6-B',
    pdfUrl: `${PDF_BASE}/21474`,
    tNumber: 'T6012401003260',
    invoiceNumber: null,
    patternStatus: 'Unknown',
    a2aAgreement: true,
    dialogueRounds: 0,
  },
  {
    id: 'inv_20260417_006b',
    rowid: 21474,
    refNumber: 'arica:21474-B',
    partnerName: '日伯コーヒー【La SOFFITTA】',
    partnerId: 83825412,
    documentType: 'invoice',
    verifiedType: 'invoice',
    issueDate: '2026-03-31',
    dueDate: '2026-04-27',
    grandTotal: 46008,
    taxBreakdown: [{ rate: '8%', subtotal: 42600, tax: 3408 }],
    details: [{
      index: 0, accountName: '仕入高', accountItemId: 858355808, taxCode: 163,
      taxCodeName: '課対仕入8%軽減', sectionName: 'La SOFFITTA', sectionId: 3068544,
      itemName: null, amount: 42600, taxAmount: 3408,
      description: 'コーヒー豆(イタリアンロースト)',
      mappingSource: '学習: "コーヒー" → 仕入高 [10/10]',
    }],
    storeName: 'La SOFFITTA',
    status: 'approved',
    confidence: 0.95,
    flags: ['2店舗分割'],
    notes: 'ラソフィッタ分。#6-A+#6-B=¥301,608',
    pdfUrl: `${PDF_BASE}/21474`,
    tNumber: 'T6012401003260',
    invoiceNumber: null,
    patternStatus: 'Unknown',
    a2aAgreement: true,
    dialogueRounds: 0,
  },
  {
    id: 'inv_20260417_007',
    rowid: 21485,
    partnerName: 'ビーバープランニングセンター',
    partnerId: 86664937,
    documentType: 'invoice',
    verifiedType: 'invoice',
    issueDate: '2026-03-31',
    dueDate: '2026-04-27',
    grandTotal: 17721,
    taxBreakdown: [{ rate: '10%', subtotal: 16110, tax: 1611 }],
    details: [
      { index: 0, accountName: '事務用品費', accountItemId: 858355834, taxCode: 136, taxCodeName: '課対仕入10%', sectionName: 'La SOFFITTA', sectionId: 3068544, itemName: 'ネームプレート代', amount: 3580, taxAmount: 358, description: 'ネームプレート×2', mappingSource: null },
      { index: 1, accountName: '事務用品費', accountItemId: 858355834, taxCode: 136, taxCodeName: '課対仕入10%', sectionName: '信州屋 新宿南口店', sectionId: 3068547, itemName: 'ネームプレート代', amount: 1790, taxAmount: 179, description: 'ネームプレート×1', mappingSource: null },
      { index: 2, accountName: '事務用品費', accountItemId: 858355834, taxCode: 136, taxCodeName: '課対仕入10%', sectionName: 'BiOcafe', sectionId: 3068548, itemName: 'ネームプレート代', amount: 3580, taxAmount: 358, description: 'ネームプレート×2', mappingSource: null },
      { index: 3, accountName: '事務用品費', accountItemId: 858355834, taxCode: 136, taxCodeName: '課対仕入10%', sectionName: '山城屋庄藏', sectionId: 3068549, itemName: 'ネームプレート代', amount: 1790, taxAmount: 179, description: 'ネームプレート×1', mappingSource: null },
      { index: 4, accountName: '事務用品費', accountItemId: 858355834, taxCode: 136, taxCodeName: '課対仕入10%', sectionName: 'Bistrot Gourmand', sectionId: 3068553, itemName: 'ネームプレート代', amount: 5370, taxAmount: 537, description: 'ネームプレート×3', mappingSource: null },
    ],
    storeName: '5部門按分',
    status: 'approved',
    confidence: 0.93,
    flags: [],
    notes: '',
    pdfUrl: `${PDF_BASE}/21485`,
    tNumber: 'T1430001025745',
    invoiceNumber: '005208',
    patternStatus: 'Unknown',
    a2aAgreement: true,
    dialogueRounds: 0,
  },
  {
    id: 'inv_20260417_008',
    rowid: 21484,
    partnerName: '岩崎(イワサキ)',
    partnerId: 83825348,
    documentType: 'invoice',
    verifiedType: 'invoice',
    issueDate: '2026-03-31',
    dueDate: '2026-04-27',
    grandTotal: 13711,
    taxBreakdown: [{ rate: '10%', subtotal: 12465, tax: 1246 }],
    details: [{
      index: 0, accountName: '賃借料', accountItemId: 858355842, taxCode: 136,
      taxCodeName: '課対仕入10%', sectionName: '信州屋 渋谷店', sectionId: 3068546,
      itemName: 'レンタル料', amount: 13711, taxAmount: 1246,
      description: '食品サンプル貸付料',
      mappingSource: '学習: 賃借料/レンタル料 [10/10]',
    }],
    storeName: '信州屋 渋谷店',
    status: 'approved',
    confidence: 0.90,
    flags: ['繰越あり(残0)'],
    notes: '繰越構造あり(繰越残=0、当月分のみ)',
    pdfUrl: `${PDF_BASE}/21484`,
    tNumber: 'T2010801001152',
    invoiceNumber: 'A 113',
    patternStatus: 'Trusted',
    a2aAgreement: true,
    dialogueRounds: 1,
  },
  {
    id: 'inv_20260417_009',
    rowid: 21483,
    partnerName: '岩崎(イワサキ)',
    partnerId: 83825348,
    documentType: 'invoice',
    verifiedType: 'invoice',
    issueDate: '2026-03-31',
    dueDate: '2026-04-27',
    grandTotal: 11355,
    taxBreakdown: [{ rate: '10%', subtotal: 10323, tax: 1032 }],
    details: [{
      index: 0, accountName: '賃借料', accountItemId: 858355842, taxCode: 136,
      taxCodeName: '課対仕入10%', sectionName: '信州屋 新宿南口店', sectionId: 3068547,
      itemName: 'レンタル料', amount: 11355, taxAmount: 1032,
      description: '食品サンプル貸付料',
      mappingSource: '学習: 賃借料/レンタル料 [10/10]',
    }],
    storeName: '信州屋 新宿南口店',
    status: 'approved',
    confidence: 0.88,
    flags: ['繰越あり(残0)'],
    notes: '繰越構造あり(繰越残=0、当月分のみ)',
    pdfUrl: `${PDF_BASE}/21483`,
    tNumber: 'T2010801001152',
    invoiceNumber: 'A 111',
    patternStatus: 'Trusted',
    a2aAgreement: true,
    dialogueRounds: 1,
  },
  {
    id: 'inv_20260417_010',
    rowid: 21482,
    partnerName: 'シーアイシー',
    partnerId: 83825354,
    documentType: 'invoice',
    verifiedType: 'invoice',
    issueDate: '2026-03-31',
    dueDate: '2026-04-27',
    grandTotal: 19250,
    taxBreakdown: [{ rate: '10%', subtotal: 17500, tax: 1750 }],
    details: [{
      index: 0, accountName: '衛生費', accountItemId: 858355722, taxCode: 136,
      taxCodeName: '課対仕入10%', sectionName: '山城屋庄藏', sectionId: 3068549,
      itemName: null, amount: 19250, taxAmount: 1750,
      description: 'ネズミ対策点検',
      mappingSource: '学習: パターン適合(衛生費)',
    }],
    storeName: '山城屋庄藏',
    status: 'approved',
    confidence: 0.95,
    flags: [],
    notes: '証憑を正として10%課税で登録',
    pdfUrl: `${PDF_BASE}/21482`,
    tNumber: 'T2010501008308',
    invoiceNumber: '202603029874',
    patternStatus: 'Trusted',
    a2aAgreement: true,
    dialogueRounds: 0,
  },
];
